import { io } from "socket.io-client";
import { hostUrl } from "./globals";

const socket = io(`${hostUrl}`, {
  path: "/ws",
  transports: ["websocket"],
  autoConnect: false,
  withCredentials: true,
});

export const connectSocketWithUser = (userId) => {
  if (!userId) return;
  // Pass the auth token so the server can verify identity + business and gate
  // room joins. userId is kept for backward compatibility (online status).
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("auth-token")
      : undefined;
  socket.auth = { userId, token };
  if (!socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};
export default socket;
